import React, { useState } from 'react';
import OnboardingTemplate from '../OnboardingTemplate';
import { FormContent } from './Login.styles';
import Button from '../Button';
import Form, { useForm } from '../Form';
import Field from '../Field';
import { useContextHook } from 'use-context-hook';
import { AuthContext } from '../../Context/authContext';
import Layout from '../Layout';
import { FcGoogle } from 'react-icons/fc';
import { Link, useNavigate } from 'react-router-dom';
import iconEmail from '../../assets/icon-email.svg';
import iconKey from '../../assets/icon-key.svg';
import { useGoogleLogin } from '@react-oauth/google';

function Login() {
  const [form] = useForm();
  const navigate = useNavigate();

  const { onLogin, loading_user, onGoogleLogin, loading_user_google } = useContextHook(AuthContext, v => ({
    onLogin: v.onLogin,
    loading_user: v.loading_user,
    // onGoogleLogin: v.onGoogleLogin,
    loading_user_google: v.loading_user_google,
  }));

  const handleSubmit = e => {
    const payload = {
      email: e?.email,
      password: e?.password,
    };
    onLogin(payload);
    // navigate('/dashboard');
  };
  // const googleLogin = useGoogleLogin({
  //   onSuccess: async tokenResponse => {
  //     const { access_token } = tokenResponse;
  //     onGoogleLogin({ access_token, action: 'Login' });
  //   },
  // });
  return (
    <>
      <Layout showTemplate={false}>
        <OnboardingTemplate>
          <FormContent>
            <div className="text-content">
              <div className="text-wrapper">
                <div className="heading-text">
                  <h1>Sign In</h1>
                </div>
                <div className="formWrapper">
                  <button className="googleAuth">
                    <div className="img-holder">
                      <FcGoogle />
                    </div>{' '}
                    Continue with Google
                  </button>
                  <div className="seprator">
                    <span className="text">Or</span>
                  </div>
                  <Form form={form} onSubmit={handleSubmit}>
                    <Form.Item
                      type="email"
                      rounded
                      lg
                      name="email"
                      placeholder="Enter your email address"
                      rules={[
                        {
                          required: true,
                          message: 'Email is Required',
                        },
                      ]}
                      prefix={<img src={iconEmail} alt="mail" width={24} height={24} />}>
                      <Field />
                    </Form.Item>
                    <Form.Item
                      type="password"
                      rounded
                      name="password"
                      placeholder="Enter password"
                      prefix={<img src={iconKey} alt="key" width={24} height={24} />}
                      rules={[
                        {
                          required: true,
                          message: 'Password is Required',
                        },
                      ]}>
                      <Field />
                    </Form.Item>
                    {/* <div className="text-box">
                      <Form.Item
                        noMargin
                        type="checkbox"
                        rounded
                        name="checkbox"
                        label={
                          <>
                            <div className="privacy">
                              <p>
                                By proceeding, you acknowledge and accept our <span className="color">Terms</span> and{' '}
                                <span className="color">Privacy Policy</span> .
                              </p>
                            </div>
                          </>
                        }>
                        <Field />
                      </Form.Item>
                      <Link className="forget-password" to="/forgot-password">
                        Forgot password
                      </Link>
                    </div> */}
                    <div className="btn-holder">
                      <Button loader={loading_user}>Continue</Button>
                    </div>
                  </Form>
                </div>
              </div>
              <div className="footer">
                Don't have an account? <Link to="/sign-up">Sign Up</Link>{' '}
              </div>
            </div>
          </FormContent>
        </OnboardingTemplate>
      </Layout>
    </>
  );
}

export default Login;
